import { useReducer, createContext } from "react"
import { CompanyReducer, initialState } from "../reducers/companyReducer"

export const CompanyContext = createContext({
    state: initialState,
    dispatch: () => null
})

export const CompanyProvider = ({ children }) => {
    const [state, dispatch] = useReducer(CompanyReducer, initialState)

    return (
        <CompanyContext.Provider value={[state, dispatch]}>
            {children}
        </CompanyContext.Provider>
    )
}